<script setup lang="ts">
interface Props {
  showText?: boolean
  label: string
  itemKey: string
  iconClass?: string
  activeKey?: string
}

interface Emits {
  (event: 'onToggle', key: string): void
}

const props = defineProps<Props>()
const emits = defineEmits<Emits>()

const isActive = computed(() => props.itemKey === props.activeKey)
</script>

<template>
  <div
    :title="props.label"
    class="flex py-2 gap-2 color-softBlack sm:color-darkGray transition-colors sm:hover:color-softBlack active:color-softBlack cursor-pointer select-none"
    :class="[
      isActive && 'color-softBlack sm:color-softBlack',
    ]"
    @click="() => emits('onToggle', props.itemKey)"
  >
    <div
      v-if="$slots.default" :class="[
        !iconClass && 'px-1',
        iconClass,
      ]"
    >
      <slot />
    </div>

    <TransitionFade>
      <div v-if="props.showText" class="flex items-center gap-2 justify-between w-full">
        <TextV2 class="font-bold whitespace-nowrap">
          {{ props.label }}
        </TextV2>

        <div
          i-mdi:chevron-right duration-125
          class="text-[24px] color-darkGray"
          :style="{
            transform: isActive ? 'rotate(-90deg)' : '',
          }"
        />
      </div>
    </TransitionFade>
  </div>
  <TransitionSlide direction="down">
    <div v-if="isActive">
      <slot name="content" />
    </div>
  </TransitionSlide>
</template>
